import { UserActions } from './actions'
import { UserGetters } from './getters'
import { UserMutations } from './mutations'
import { UserState } from './state'

export const USER_NAMESPACE = 'user'

export const User = {
  namespaced: true,
  state: UserState,
  actions: UserActions,
  mutations: UserMutations,
  getters: UserGetters,
}
